import { AnfrageDisplayModel } from './../../../api/models/ace/xFound/Portal/Core/CAQ/Models/anfrage-display-model';
import { PortalContextService } from '@/core/services/portal-context.service';
import { SectionService } from '@/core/services/section.service';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { FormGroup } from '@angular/forms';
import { BaseNavigationFormComponent } from '../base-navigation-form/base-navigation-form.component';

export enum MoveDirection {
  STAY,
  NEXT,
  BACK
}

@Component({
  selector: 'anfrage-navigation-form',
  template: ''
})
export abstract class AnfrageNavigationFormComponent extends BaseNavigationFormComponent implements OnInit {

  protected anfrage: AnfrageDisplayModel;

  constructor(
    protected sectionService: SectionService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected portalContextService: PortalContextService,
  ) {
    super(sectionService, router, route, portalContextService);

    this.anfrage = this.portalContextService.CurrentAnfrage;


  }

  ngOnInit(): void {
    let navigationStart: Observable<NavigationStart> = this.router.events.pipe(filter(event => event instanceof NavigationStart), map(event => <NavigationStart>event));
    this.subscriptions.push(navigationStart.subscribe(() => {
      if (this.formGroup.touched || this.formGroup.dirty)
        this.save(!this.portalContextService.isAnfrageDisabled(), MoveDirection.STAY);
    }));

    let navigationEnd: Observable<NavigationEnd> = this.router.events.pipe(filter(event => event instanceof NavigationEnd), map(event => <NavigationEnd>event));
    this.subscriptions.push(navigationEnd.subscribe(() => {
      if (this.portalContextService.isAnfrageDisabled())
        this.formGroup.disable();
      else
        this.formGroup.enable();
    }))
    
    if (this.portalContextService.isAnfrageDisabled())
      this.formGroup.disable();
  }
  protected abstract save(shouldSave: boolean, moveDirection: MoveDirection): void;
  public abstract get formGroup(): FormGroup;
}
